export default __webpack_public_path__ + "static/bestie-4-3797a38800c10e9bd8608a5529e6f2ac.webp";